import React from "react"
import { Container, Column, Columns, Content } from "bloomer"

import Layout from "../components/layout"
import SEO from "../components/seo"
import AnjosForm from "../components/anjosForm"
import BreadcrumbJsonLd from "../components/breadcrumb-jsonld"
import OutrosJogos from "../components/outros-jogos"

const AnjoDaGuarda = () => (
  <Layout>
    <SEO
      title="Anjo da Guarda pela Data de Nascimento — Descubra o seu | EstrelaGuia"
      description="Descubra qual é o seu Anjo da Guarda pela sua data de nascimento. Informe o dia e o mês e conheça o anjo que protege e guia a sua vida."
      pathname="/anjo-da-guarda/"
      image="/og/anjo-da-guarda.png"
    />
    <BreadcrumbJsonLd
      trail={[
        { name: "Início", path: "/" },
        { name: "Anjos", path: "/anjos/" },
        { name: "Anjo da Guarda pela data de nascimento", path: "/anjo-da-guarda/" },
      ]}
    />
    <Container>
      <Columns>
        <Column>
          <Content>
            <h1>Anjo da Guarda pela data de nascimento</h1>
            <p>
              Cada pessoa tem um Anjo da Guarda que a acompanha desde o nascimento,
              de acordo com a tradição cabalística dos 72 anjos. Informe o seu dia
              e mês de nascimento abaixo e descubra qual é o seu anjo protetor — com
              o salmo, a cor, o aroma, a pedra e o horário de cada um.
            </p>
          </Content>
          <AnjosForm />
          <Content>
            <h2>O que é o Anjo da Guarda</h2>
            <p>
              O Anjo é uma criatura celestial, um ser intermediário entre o divino e
              os homens, que protege e guia cada pessoa ao longo da vida. Na tradição
              cabalística, os 72 anjos se distribuem pelo ano, e cada um rege um
              período de poucos dias. Descobrir o seu é o primeiro passo para invocar
              a sua proteção e entender os dons que ele desperta em você.
            </p>
            <h2>Como descobrir o seu anjo</h2>
            <p>
              Basta informar o dia e o mês do seu nascimento no campo acima. Em
              seguida você verá a página do seu Anjo da Guarda, com o significado, o
              salmo para invocá-lo e os elementos ligados a ele.
            </p>
          </Content>
        <OutrosJogos atual="/anjo-da-guarda/" />
          </Column>
      </Columns>
    </Container>
  </Layout>
)

export default AnjoDaGuarda
